module.exports = __webpack_public_path__ + "static/media/n_service-report-tag@2x.715a09c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_service-report-tag@2x.png
// module id = 1824
// module chunks = 0 1